import { Dialog, DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { inject, Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialog = inject(Dialog);

  openDialog<R, C, D>(
    component: Type<C>,
    data?: D,
    config?: DialogConfig<D, DialogRef<R, C>>,
  ): Observable<R | undefined /* undefined when ESC or click outside */> {
    const defaultConfig: DialogConfig<D, DialogRef<R, C>> = {
      autoFocus: undefined, // no autofocus. Set it to 'first-tabbable' to focus specific element with tabindex attribute)
      panelClass: 'overflow-y-auto md:overflow-y-visible'.split(' '), // show scrollbar only on mobile browsers, as it looks quite good, unlike on the desktop browsers.
    };
    const dialogRef = this.dialog.open<R, D, C>(component, { ...defaultConfig, ...config, data });

    return dialogRef.closed;
  }
}
